import { v4 as uuidv4 } from 'uuid';

const ANON_ID_COOKIE_NAME = 'ajs_anonymous_id';

export const getAnonId = (
    cookies: Record<string, string | undefined>
): string => {
    const anonId = cookies[ANON_ID_COOKIE_NAME];

const doubleQuoteRegex = /\"/g;
return typeof anonId !== 'undefined' ? anonId.replace(doubleQuoteRegex, '') : uuidv4();
};
